var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70%",
    height: "100%",
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18H8V40H0V18ZM30 2.5C31.3 0.98 33.32 0 35.4 0C39.1 0 42 2.9 42 6.6C42 11.14 36.18 16.4 30 22C23.82 16.38 18 11.12 18 6.6C18 2.9 20.9 0 24.6 0C26.68 0 28.7 0.98 30 2.5ZM38 30H24L19.82 28.54L20.48 26.66L24 28H29.64C30.94 28 32 26.94 32 25.64C32 24.66 31.38 23.78 30.46 23.42L15.94 18H12V36.04L26 40L42.02 34C42 31.8 40.22 30 38 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharity);
export default __webpack_public_path__ + "static/media/Charity.8cb6512fe6496a89397ae7ed8aa7f4e1.svg";
export { ForwardRef as ReactComponent };